
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbZqw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $awd1Q = parcelRequire("awd1Q");


var $7boqA = parcelRequire("7boqA");


var $jX1qB = parcelRequire("jX1qB");








var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $3IZob = parcelRequire("3IZob");


var $b3j2Y = parcelRequire("b3j2Y");


var $jtuBN = parcelRequire("jtuBN");


var $9wGTI = parcelRequire("9wGTI");


var $h2uld = parcelRequire("h2uld");











var $4n1IT = parcelRequire("4n1IT");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");





var $hekY6 = parcelRequire("hekY6");





var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");





var $1KLPb = parcelRequire("1KLPb");


var $3izAL = parcelRequire("3izAL");





var $kvJHJ = parcelRequire("kvJHJ");


var $luv00 = parcelRequire("luv00");




const $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    abbreviatedReadTime: {
        id: "read-time.by-line.abbreviated-estimated-read-time",
        defaultMessage: "{readTime} min"
    },
    abbreviatedReadTimeCapped: {
        id: "read-time.by-line.abbreviated-estimated-read-time-capped",
        defaultMessage: "{readTime}+ min"
    },
    readTime: {
        id: "read-time.by-line.estimated-read-time",
        defaultMessage: "{readTime} min read"
    },
    readTimeCapped: {
        id: "read-time.by-line.estimated-read-time-capped",
        defaultMessage: "{readTime}+ min read"
    },
    iconLabel: {
        id: "read-time.by-line.icon-label",
        defaultMessage: "Read time"
    },
    tooltipDescription: {
        id: "read-time.tooltip-description",
        defaultMessage: "Estimated read time"
    },
    wordCount: {
        id: "read-time.word-count",
        defaultMessage: "{wordCount} {wordCount, plural, one {word} other {words}}"
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    width: 'max-content',
    height: '24px'
});
const $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles = (0, $buxP3.xcss)({
    display: 'inline-flex'
});
const $cdcc5f8fb5019e0d$var$baseStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$detailsPanelStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$detailsPanelTextStyles = (0, $buxP3.xcss)({
    font: 'font.body',
    color: 'color.text.subtle',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeBadgeStyles = null;
const $cdcc5f8fb5019e0d$var$readTimeBullet = null;
function $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { pageId: pageId, readTime: readTime, isAbbreviatedReadTime: t1, isInEditor: isInEditor, isDetailsPanel: isDetailsPanel, wordCount: wordCount, showWordCount: showWordCount, isReadTimeCapped: isReadTimeCapped } = t0;
    const isAbbreviatedReadTime = t1 === undefined ? true : t1;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== isInEditor) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "displayed",
                    actionSubject: "tooltip",
                    actionSubjectId: "estimatedReadTime",
                    attributes: {
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isInEditor;
        $[2] = t2;
    } else t2 = $[2];
    const fireTooltipEvent = t2;
    let t3;
    let t4;
    if ($[3] !== createAnalyticsEvent || $[4] !== isInEditor || $[5] !== pageId || $[6] !== readTime) {
        t3 = ()=>{
            if (readTime) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "confluence-frontend",
                    action: "displayed",
                    actionSubject: "readTime",
                    actionSubjectId: pageId,
                    attributes: {
                        readTime: readTime,
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        t4 = [
            pageId,
            readTime,
            createAnalyticsEvent,
            isInEditor
        ];
        $[3] = createAnalyticsEvent;
        $[4] = isInEditor;
        $[5] = pageId;
        $[6] = readTime;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const readTimeMessage = isAbbreviatedReadTime ? isReadTimeCapped ? $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.abbreviatedReadTimeCapped : $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.abbreviatedReadTime : isReadTimeCapped ? $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.readTimeCapped : $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.readTime;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "inline-flex"
        };
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== formatMessage || $[11] !== isDetailsPanel || $[12] !== showWordCount || $[13] !== wordCount) {
        t6 = showWordCount && wordCount != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                isDetailsPanel && $cdcc5f8fb5019e0d$var$detailsPanelTextStyles
            ]
        }, formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.wordCount, {
            wordCount: wordCount
        }));
        $[10] = formatMessage;
        $[11] = isDetailsPanel;
        $[12] = showWordCount;
        $[13] = wordCount;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== fireTooltipEvent || $[16] !== formatMessage || $[17] !== isAbbreviatedReadTime || $[18] !== isDetailsPanel || $[19] !== readTime || $[20] !== readTimeMessage) {
        t7 = !!readTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                !isAbbreviatedReadTime && "_1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _3Ku51IbQDk _0OU75rvbI6 _1eQ8NNZpcK _1F91ci2ADO",
                isDetailsPanel ? "_0adFHsdnbC _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _3Ku51IbQDk _0OU75rvbI6 _1eQ8NNZpcK _1F91ci1Y8M _1UtDrQ1Y8M" : "_0adFHs1Y8M _2Zuz6QgVvo _1UtDYzZpcK",
                isAbbreviatedReadTime && "_0adFHsPgdg _2Zuz6Q1Y8M _1Znuxb1Y8M _0wOv4Q7zJH _0jFU0VoWWg _0Am33zKxmn _1eOmH6o126"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            tag: "span",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.tooltipDescription),
            onShow: fireTooltipEvent,
            hideTooltipOnClick: true,
            delay: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                isAbbreviatedReadTime ? $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles : $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles,
                isDetailsPanel && $cdcc5f8fb5019e0d$var$detailsPanelTextStyles
            ]
        }, isAbbreviatedReadTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KLPb))), {
            label: formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.iconLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...readTimeMessage,
            values: {
                readTime: readTime
            }
        }))));
        $[15] = fireTooltipEvent;
        $[16] = formatMessage;
        $[17] = isAbbreviatedReadTime;
        $[18] = isDetailsPanel;
        $[19] = readTime;
        $[20] = readTimeMessage;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metricKey: (0, $jX1qB.READ_TIME_SEGMENT_KEY)
        });
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== ssrPlaceholderIdProp || $[24] !== t6 || $[25] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc": "read-time",
            "data-testid": "read-time-component",
            ...ssrPlaceholderIdProp,
            style: t5
        }, t6, t7, t8);
        $[23] = ssrPlaceholderIdProp;
        $[24] = t6;
        $[25] = t7;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
}



const $b2726d89c406a12d$var$ReadTimePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wHxOo",
    name: "ReadTimePopup",
    loader: async ()=>(await (parcelRequire("5uMgc"))).ReadTimePopup
});
const $b2726d89c406a12d$var$triggerStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    color: 'color.text',
    font: 'font.body.small',
    padding: 'space.0',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle'
});
const $b2726d89c406a12d$export$eb6727f1763071f3 = (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount, features: features, featuresSkipExpand: featuresSkipExpand, wordCount: wordCount, readTime: readTime, source: source, isReadTimeCapped: isReadTimeCapped } = t0;
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== isPopupOpen || $[3] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "readTime",
                    actionSubjectId: "readTimePopup",
                    source: source,
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            setIsPopupOpen(!isPopupOpen);
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = isPopupOpen;
        $[3] = source;
        $[4] = t1;
    } else t1 = $[4];
    const onPageReadTimeClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true);
        $[5] = t2;
    } else t2 = $[5];
    const shouldRenderToParent = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsPopupOpen(false);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== contentId || $[8] !== features || $[9] !== featuresSkipExpand || $[10] !== source) {
        t4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b2726d89c406a12d$var$ReadTimePopup, {
                ...props,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                source: source,
                contentId: contentId
            });
        $[7] = contentId;
        $[8] = features;
        $[9] = featuresSkipExpand;
        $[10] = source;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== contentId || $[13] !== isAbbreviatedReadTime || $[14] !== isDetailsPanel || $[15] !== isReadTimeCapped || $[16] !== onPageReadTimeClick || $[17] !== readTime || $[18] !== showWordCount || $[19] !== wordCount) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                ...triggerProps,
                onClick: onPageReadTimeClick,
                xcss: $b2726d89c406a12d$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7), {
                readTime: readTime,
                wordCount: wordCount,
                pageId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount,
                isReadTimeCapped: isReadTimeCapped
            }));
        $[12] = contentId;
        $[13] = isAbbreviatedReadTime;
        $[14] = isDetailsPanel;
        $[15] = isReadTimeCapped;
        $[16] = onPageReadTimeClick;
        $[17] = readTime;
        $[18] = showWordCount;
        $[19] = wordCount;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== isPopupOpen || $[22] !== t4 || $[23] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isPopupOpen,
            onClose: t3,
            placement: "bottom-start",
            shouldRenderToParent: shouldRenderToParent,
            content: t4,
            trigger: t5
        });
        $[21] = isPopupOpen;
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
};



var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $80e642dbd56c6416$export$961bca700bc56c3 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { contentId: contentId, editorApi: editorApi, showWordCount: showWordCount, isDetailsPanel: isDetailsPanel, isAbbreviatedReadTime: t1 } = t0;
    const isAbbreviatedReadTime = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            "current",
            "draft"
        ];
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== contentId) {
        t3 = {
            variables: {
                contentId: contentId,
                status: t2
            }
        };
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const readTimeQueryOptions = t3;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $h2uld.ReadTimeQuery), {
        ...readTimeQueryOptions,
        __callerPackage__: "read-time"
    });
    const t4 = data ?? undefined;
    let t5;
    if ($[3] !== t4) {
        t5 = (0, $72md5.getAdf)(t4);
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    const adf = t5;
    const t6 = data ?? undefined;
    let t7;
    if ($[5] !== t6) {
        t7 = (0, $72md5.getAdfString)(t6);
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    const adfString = t7;
    let t8;
    if (adf && (0, $9wGTI.fg)("read_time_parse_dedup")) {
        let featuresSkipExpand;
        let t9;
        if ($[7] !== adf || $[8] !== adfString?.length) {
            const { featuresSkipExpand: t10, nodeCount: nodeCount } = (0, $h3vPv.extractAllContentFeatures)(adf, adfString?.length);
            featuresSkipExpand = t10;
            t9 = (0, $72md5.readTimeFromFeatures)(featuresSkipExpand, nodeCount);
            $[7] = adf;
            $[8] = adfString?.length;
            $[9] = featuresSkipExpand;
            $[10] = t9;
        } else {
            featuresSkipExpand = $[9];
            t9 = $[10];
        }
        const { readTime: readTime, isReadTimeCapped: isReadTimeCapped } = t9;
        const t10 = isReadTimeCapped ? null : featuresSkipExpand.wordCount;
        let t11;
        if ($[11] !== isReadTimeCapped || $[12] !== readTime || $[13] !== t10) {
            t11 = {
                readTime: readTime,
                wordCount: t10,
                isReadTimeCapped: isReadTimeCapped
            };
            $[11] = isReadTimeCapped;
            $[12] = readTime;
            $[13] = t10;
            $[14] = t11;
        } else t11 = $[14];
        t8 = t11;
    } else {
        let t9;
        if ($[15] !== adf) {
            t9 = (0, $72md5.calculateEstimatedReadTime)(adf);
            $[15] = adf;
            $[16] = t9;
        } else t9 = $[16];
        let t10;
        if ($[17] !== adf) {
            t10 = (0, $72md5.getWordCount)(adf);
            $[17] = adf;
            $[18] = t10;
        } else t10 = $[18];
        let t11;
        if ($[19] !== t10 || $[20] !== t9) {
            t11 = {
                readTime: t9,
                wordCount: t10,
                isReadTimeCapped: false
            };
            $[19] = t10;
            $[20] = t9;
            $[21] = t11;
        } else t11 = $[21];
        t8 = t11;
    }
    const queryReadTime = t8;
    const [readTime_0, setReadTime] = (0, $cozmU.useState)(queryReadTime.readTime);
    const [wordCount, setWordCount] = (0, $cozmU.useState)(queryReadTime.wordCount);
    const [isReadTimeCapped_0, setIsReadTimeCapped] = (0, $cozmU.useState)(queryReadTime.isReadTimeCapped);
    const [features, setFeatures] = (0, $cozmU.useState)(null);
    const [featuresSkipExpand_0, setFeaturesSkipExpand] = (0, $cozmU.useState)(null);
    const lastAdfStringRef = (0, $cozmU.useRef)(adfString);
    let t9;
    if ($[22] !== adf || $[23] !== contentId || $[24] !== createAnalyticsEvent || $[25] !== data?.content?.nodes?.[0]?.type || $[26] !== error || $[27] !== loading) {
        t9 = ()=>{
            if (!createAnalyticsEvent || !adf || loading || error || !contentId) return;
            const contentType = data?.content?.nodes?.[0]?.type ?? "";
            createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
                contentType: contentType,
                contentId: contentId,
                adf: adf,
                isInEditor: true
            })).fire();
        };
        $[22] = adf;
        $[23] = contentId;
        $[24] = createAnalyticsEvent;
        $[25] = data?.content?.nodes?.[0]?.type;
        $[26] = error;
        $[27] = loading;
        $[28] = t9;
    } else t9 = $[28];
    const t10 = data?.content?.nodes;
    let t11;
    if ($[29] !== adf || $[30] !== contentId || $[31] !== createAnalyticsEvent || $[32] !== error || $[33] !== loading || $[34] !== t10) {
        t11 = [
            contentId,
            loading,
            adf,
            t10,
            error,
            createAnalyticsEvent
        ];
        $[29] = adf;
        $[30] = contentId;
        $[31] = createAnalyticsEvent;
        $[32] = error;
        $[33] = loading;
        $[34] = t10;
        $[35] = t11;
    } else t11 = $[35];
    (0, $cozmU.useEffect)(t9, t11);
    let t12;
    if ($[36] !== adf || $[37] !== adfString || $[38] !== error || $[39] !== loading || $[40] !== queryReadTime.isReadTimeCapped || $[41] !== queryReadTime.readTime || $[42] !== queryReadTime.wordCount) {
        t12 = ()=>{
            if (adf && !loading && !error && adfString !== lastAdfStringRef.current) {
                lastAdfStringRef.current = adfString;
                setReadTime(queryReadTime.readTime);
                setWordCount(queryReadTime.wordCount);
                setIsReadTimeCapped(queryReadTime.isReadTimeCapped);
            }
        };
        $[36] = adf;
        $[37] = adfString;
        $[38] = error;
        $[39] = loading;
        $[40] = queryReadTime.isReadTimeCapped;
        $[41] = queryReadTime.readTime;
        $[42] = queryReadTime.wordCount;
        $[43] = t12;
    } else t12 = $[43];
    let t13;
    if ($[44] !== adf || $[45] !== adfString || $[46] !== error || $[47] !== loading || $[48] !== queryReadTime) {
        t13 = [
            adf,
            adfString,
            loading,
            error,
            queryReadTime
        ];
        $[44] = adf;
        $[45] = adfString;
        $[46] = error;
        $[47] = loading;
        $[48] = queryReadTime;
        $[49] = t13;
    } else t13 = $[49];
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    if ($[50] !== editorApi) {
        t14 = async ()=>{
            if (editorApi) editorApi.core?.actions.requestDocument((doc)=>{
                if (!doc) {
                    setReadTime(0);
                    setWordCount(0);
                    setIsReadTimeCapped(false);
                } else if ((0, $9wGTI.fg)("read_time_parse_dedup")) {
                    const { features: allFeatures, featuresSkipExpand: allFeaturesSkipExpand, nodeCount: nodeCount_0 } = (0, $h3vPv.extractAllContentFeatures)(doc);
                    const { readTime: editorReadTime, isReadTimeCapped: editorCapped } = (0, $72md5.readTimeFromFeatures)(allFeaturesSkipExpand, nodeCount_0);
                    setReadTime(editorReadTime);
                    setIsReadTimeCapped(editorCapped);
                    if (editorCapped) {
                        setWordCount(null);
                        setFeatures(null);
                        setFeaturesSkipExpand(null);
                    } else {
                        setWordCount(allFeaturesSkipExpand.wordCount);
                        setFeatures(allFeatures);
                        setFeaturesSkipExpand(allFeaturesSkipExpand);
                    }
                } else {
                    setWordCount((0, $72md5.getWordCount)(doc));
                    setReadTime((0, $72md5.calculateEstimatedReadTime)(doc));
                    setFeatures((0, $h3vPv.extractContentFeatures)(doc));
                    setFeaturesSkipExpand((0, $h3vPv.extractContentFeaturesSkipExpand)(doc));
                }
            });
        };
        $[50] = editorApi;
        $[51] = t14;
    } else t14 = $[51];
    const setReadTimeFromEditorState = t14;
    let t15;
    let t16;
    if ($[52] !== setReadTimeFromEditorState) {
        t15 = ()=>{
            setReadTimeFromEditorState();
        };
        t16 = [
            setReadTimeFromEditorState
        ];
        $[52] = setReadTimeFromEditorState;
        $[53] = t15;
        $[54] = t16;
    } else {
        t15 = $[53];
        t16 = $[54];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    if ($[55] !== setReadTimeFromEditorState) {
        t17 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(setReadTimeFromEditorState, 5000);
        $[55] = setReadTimeFromEditorState;
        $[56] = t17;
    } else t17 = $[56];
    const debouncedCalculateReadTime = t17;
    let t18;
    let t19;
    if ($[57] !== debouncedCalculateReadTime || $[58] !== subscribeDocChange || $[59] !== unsubscribeDocChange) {
        t18 = ()=>{
            subscribeDocChange(debouncedCalculateReadTime);
            return ()=>unsubscribeDocChange(debouncedCalculateReadTime);
        };
        t19 = [
            debouncedCalculateReadTime,
            subscribeDocChange,
            unsubscribeDocChange
        ];
        $[57] = debouncedCalculateReadTime;
        $[58] = subscribeDocChange;
        $[59] = unsubscribeDocChange;
        $[60] = t18;
        $[61] = t19;
    } else {
        t18 = $[60];
        t19 = $[61];
    }
    (0, $cozmU.useEffect)(t18, t19);
    if (error) {
        let t20;
        if ($[62] !== error) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[62] = error;
            $[63] = t20;
        } else t20 = $[63];
        return t20;
    }
    if (readTime_0 || showWordCount && wordCount != null) {
        let t20;
        if ($[64] !== contentId || $[65] !== features || $[66] !== featuresSkipExpand_0 || $[67] !== isAbbreviatedReadTime || $[68] !== isDetailsPanel || $[69] !== isReadTimeCapped_0 || $[70] !== readTime_0 || $[71] !== showWordCount || $[72] !== wordCount) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
                contentId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount,
                features: features,
                featuresSkipExpand: featuresSkipExpand_0,
                wordCount: wordCount,
                readTime: readTime_0,
                source: "editorReadTime",
                isReadTimeCapped: isReadTimeCapped_0
            });
            $[64] = contentId;
            $[65] = features;
            $[66] = featuresSkipExpand_0;
            $[67] = isAbbreviatedReadTime;
            $[68] = isDetailsPanel;
            $[69] = isReadTimeCapped_0;
            $[70] = readTime_0;
            $[71] = showWordCount;
            $[72] = wordCount;
            $[73] = t20;
        } else t20 = $[73];
        return t20;
    }
});


/**
 * @graphql cc
 */ 


















const $70e8bb0fe98c8861$export$8b2e5877d9d93c3c = ({ contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { adf: adf, loading: loading, error: error, contentType: contentType, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand, isReadTimeCapped: isReadTimeCapped } = (0, $h2uld.useReadTime)(contentId);
    (0, $cozmU.useEffect)(()=>{
        if (createAnalyticsEvent && adf && !loading && !error && contentId && contentType) {
            if ((0, $9wGTI.fg)('read_time_parse_dedup')) {
                if (features) createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObjectFromFeatures)({
                    contentType: contentType,
                    contentId: contentId,
                    features: features,
                    isInEditor: false
                })).fire();
            } else createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
                contentType: contentType,
                contentId: contentId,
                adf: adf,
                isInEditor: false
            })).fire();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- features derived from adf
    }, [
        contentId,
        loading,
        error,
        contentType,
        createAnalyticsEvent,
        adf,
        features
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (readTime || showWordCount && wordCount !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
        contentId: contentId,
        isAbbreviatedReadTime: isAbbreviatedReadTime,
        isDetailsPanel: isDetailsPanel,
        showWordCount: showWordCount,
        features: features,
        featuresSkipExpand: featuresSkipExpand,
        wordCount: wordCount,
        readTime: readTime,
        source: "originalReadTime",
        isReadTimeCapped: isReadTimeCapped
    });
    return null;
};


const $8f3b07438f5b7ca3$export$77dedcd16f070a20 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId, editorApi: editorApi, isInEditor: isInEditor, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    const { locale: locale } = (0, $awd1Q.getTranslation)();
    const shouldRenderReadTime = locale && locale.substring(0, 2).toLowerCase() === "en";
    if (!shouldRenderReadTime) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metricKey: (0, $jX1qB.READ_TIME_SEGMENT_KEY)
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== editorApi || $[3] !== isAbbreviatedReadTime || $[4] !== isDetailsPanel || $[5] !== isInEditor || $[6] !== showWordCount) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, isInEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80e642dbd56c6416$export$961bca700bc56c3), {
            contentId: contentId,
            editorApi: editorApi,
            showWordCount: showWordCount,
            isDetailsPanel: isDetailsPanel,
            isAbbreviatedReadTime: isAbbreviatedReadTime
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70e8bb0fe98c8861$export$8b2e5877d9d93c3c), {
            contentId: contentId,
            isAbbreviatedReadTime: isAbbreviatedReadTime,
            isDetailsPanel: isDetailsPanel,
            showWordCount: showWordCount
        }));
        $[1] = contentId;
        $[2] = editorApi;
        $[3] = isAbbreviatedReadTime;
        $[4] = isDetailsPanel;
        $[5] = isInEditor;
        $[6] = showWordCount;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
module.exports["ReadTime"] = $8f3b07438f5b7ca3$export$77dedcd16f070a20;

});

parcelRegister("3IZob", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $cozmU.useRef)(new Set());
    const handleDocChange = (0, $cozmU.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $cozmU.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $cozmU.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $cozmU.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("1KLPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a05e8365b19766ca73e82e6f6133ae2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $146f2f46410fb12f$var$_react = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $146f2f46410fb12f$var$_baseNew = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $146f2f46410fb12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/book-open
 * Usage guidance:
 * Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $146f2f46410fb12f$var$BookOpenIcon = (props)=>/*#__PURE__*/ $146f2f46410fb12f$var$_react.default.createElement($146f2f46410fb12f$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$146f2f46410fb12f$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $146f2f46410fb12f$var$_default = module.exports.default = $146f2f46410fb12f$var$BookOpenIcon;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("5uMgc", function(module, exports) {

let $4005309a92dea350$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4005309a92dea350$var$load("52ZTT"),
    $4005309a92dea350$var$load("6wr18"),
    $4005309a92dea350$var$load("ffEVr"),
    $4005309a92dea350$var$load("57PKM"),
    $4005309a92dea350$var$load("excC5"),
    $4005309a92dea350$var$load("kGmwI"),
    $4005309a92dea350$var$load("bAAmE")
]).then(()=>parcelRequire('jgpqF'));

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});


//# sourceMappingURL=ReadTime.28c230a4.js.map
